import { AuthorizeResponse } from '../api/models/Authorize';

export enum AccessTokenLocalStorageKeys {
  AccessToken = 'accessToken',
}

export const getAccessTokenFromLocalStorage = () => {
  return JSON.parse(
    localStorage.getItem(AccessTokenLocalStorageKeys.AccessToken) as string
  ) as AuthorizeResponse;
};

export const setAuthTokenValuesInLocalStorage = (token: AuthorizeResponse) => {
  localStorage.setItem(
    AccessTokenLocalStorageKeys.AccessToken,
    JSON.stringify(token)
  );
};

export const removeAuthTokenValuesFromLocalStorage = () => {
  localStorage.removeItem(AccessTokenLocalStorageKeys.AccessToken);
};
